import { IconButton, makeStyles, Tooltip } from "@material-ui/core";
import { CloudDownload, Description } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  exportButton: {
    color: theme.palette.text.secondary,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.primary.main,
    },
  },
}));

export function DeltaExportActions({
  onCsvExport,
  onExcelExport,
}: {
  onCsvExport: () => void;
  onExcelExport: () => void;
}) {
  const classes = useStyles();

  return (
    <>
      <Tooltip title="Download CSV">
        <IconButton
          className={classes.exportButton}
          onClick={onCsvExport}
          size="small"
        >
          <CloudDownload />
        </IconButton>
      </Tooltip>
      <Tooltip title="Download Excel (.xlsx)">
        <IconButton
          className={classes.exportButton}
          onClick={onExcelExport}
          size="small"
        >
          <Description />
        </IconButton>
      </Tooltip>
    </>
  );
}
